import { Entity, isApiEntity } from '@backstage/catalog-model';

export const MCP_SERVER_API_TYPE = 'mcp-server';

export type McpRemote = {
  type: string;
  url: string;
};

export type McpServerApiEntity = Entity & {
  spec: {
    type: typeof MCP_SERVER_API_TYPE;
    remotes?: McpRemote[];
    definition?: unknown;
  };
};

export const isApiEntityMcpServer = (entity: Entity): entity is McpServerApiEntity =>
  isApiEntity(entity) && entity.spec.type === MCP_SERVER_API_TYPE;
